import React, {useEffect, useState} from "react";
import CountUp from "react-countup";
import {CountUpUtil} from "app/utils/countUpUtil";
import {round} from "app/utils/stringUtil";
import {Link} from "react-router-dom";
import {useAppSelector} from "../../../store/hook";
import DashboardLoading from "./DashboardLoading";
import DashboardNoData from "./DashboardNoData";
import {DbUserService} from "../../../services/db/dbUserService";
import {ResponseResultCode} from "../../../model/response-api";
import moment from "moment";
import {DashboardModuleProps} from "../../../model/db/dashboardModuleProps";
import DashboardCard from "./DashboardCard";

const today = moment().format('YYYYMMDD');

interface EssDataModel {
  crtrYmd?: string;
  chngPwr?: number;
  dschgPwr?: number;
  chngRt?: number;
}

export default function EssLiveStatus(props: Readonly<DashboardModuleProps>) {
  const hasEss = useAppSelector((state) => state.mgResource.hasEss);
  const [tab, setTab] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [todayEssData, setTodayEssData] = useState<EssDataModel>();
  const [yesterdayEssData, setYesterdayEssData] = useState<EssDataModel>();
  const [essData, setEssData] = useState<EssDataModel>();

  useEffect(() => {
    DbUserService.getInstance().fetchEssData().then(result => {
      let todayData: EssDataModel = {};
      let yesterdayData: EssDataModel  = {};

      if (result && result.resultCode === ResponseResultCode.Y && result.data) {
        const data = result.data;
        todayData = data.find((d: any) => d.crtrYmd === today);
        yesterdayData = data.find((d: any) => d.crtrYmd !== today);
      }

      setTodayEssData(todayData);
      setYesterdayEssData(yesterdayData);
      setTab('today');
    }).finally(() => {
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    if (tab === 'today') {
      setEssData(todayEssData);
    } else {
      setEssData(yesterdayEssData);
    }
  }, [tab]);

  return (
    <DashboardCard
      title="ESS 현황"
      isConfigMode={props.isConfigMode ?? false}
      moreButtonVisible={true}
      moreButtonUrl="/pc/renewal/ess"
      dashboardConfig={props.dashboardConfig}
    >
      <DashboardLoading isLoading={isLoading} />
      {/*{!isLoading && !hasEss ? (*/}
      {/*  <DashboardNoData message="등록된 ESS 자원이 없습니다." />*/}
      {/*) : (*/}
        <>
          {/*{essData && (*/}
          <div className="inner-flex1">
            <div className="tab-st-box6">
              <ul className="tab-st6 block">
                <li className={tab === 'today' ? 'on' : ''}>
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setTab('today');
                    }}
                    title="금일 ESS정보">
                    <span>금일 ESS정보</span>
                  </Link>
                </li>
                <li className={tab === 'yesterday' ? 'on' : ''}>
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setTab('yesterday');
                    }}
                    title="전일 ESS정보">
                    <span>전일 ESS정보</span>
                  </Link>
                </li>
              </ul>
            </div>
            <div className="box-flex">
              <div className="d-icon-box1">
                <p><span className="icon1"></span><span>SOC</span></p>
                <strong className="c-num">
                  {essData?.chngRt ? (
                    <em className="big">
                      <CountUp
                        end={round(essData?.chngRt, 2)}
                        duration={0.5}  // 애니메이션 지속 시간
                        decimals={CountUpUtil.getDecimal(round(essData?.chngRt, 2))}
                      />
                    </em>
                  ) : (
                    <>-</>
                  )}
                  %
                </strong>
              </div>
              <div className="d-icon-box1">
                <p><span className="icon2"></span><span>방전량</span></p>
                <strong className="c-num">
                  {essData?.dschgPwr ? (
                    <em className="big">
                      <CountUp
                        end={round(essData?.dschgPwr, 2)}
                        duration={0.5}  // 애니메이션 지속 시간
                        decimals={CountUpUtil.getDecimal(round(essData?.dschgPwr, 2))}
                      />
                    </em>
                  ) : (
                    <>-</>
                  )}
                  kWh
                </strong>
              </div>
              <div className="d-icon-box1">
                <p><span className="icon3"></span><span>충전량</span></p>
                <strong className="c-num">
                  {essData?.chngPwr ? (
                    <em className="big">
                      <CountUp
                        end={round(essData?.chngPwr, 2)}
                        duration={0.5}  // 애니메이션 지속 시간
                        decimals={CountUpUtil.getDecimal(round(essData?.chngPwr, 2))}
                      />
                    </em>
                  ) : (
                    <>-</>
                  )}
                  kWh
                </strong>
              </div>
            </div>
          </div>
          {/*)}*/}
        </>
      {/*)}*/}
    </DashboardCard>
  );
}